import { createFileRoute, redirect } from '@tanstack/react-router';
import { membershipsQueryOptions } from '@/api/queries/useMemberships';
import { SelectWorkspacePage } from '@/pages/auth/select-workspace/selectWorkspacePage';
import { requireAuthenticated } from '@/lib/auth/authSnapshot';

// Lives outside $slug on purpose: the screen spans workspaces, so a
// slug-scoped guard could never host it.
export const Route = createFileRoute('/select-workspace')({
  beforeLoad: () => {
    requireAuthenticated();
  },
  // A direct visit (bookmark, refresh) with nothing to choose falls through
  // to the normal signed-in destination instead of a one-option picker.
  loader: async ({ context }) => {
    const { memberships } = await context.queryClient.ensureQueryData(membershipsQueryOptions);
    if (memberships.length <= 1) {
      // Re-assert AFTER the await: a concurrent 401 teardown during the fetch
      // clears the store, and an empty slug would interpolate a junk /$slug.
      const auth = requireAuthenticated();
      if (auth.isSuperAdmin) {
        throw redirect({ to: '/admin/tenants' });
      }
      throw redirect({ to: '/$slug', params: { slug: auth.slug } });
    }
  },
  component: SelectWorkspacePage
});
